var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.078 23.8224C15.4919 32.4878 22.5425 39.5295 31.2153 43.9383L37.9399 37.1999C38.7832 36.3566 39.9851 36.1162 41.0423 36.4523C44.4569 37.5812 48.1407 38.1942 51.9442 38.1942C53.6395 38.1942 55 39.5547 55 41.25V51.9442C55 53.6395 53.6395 55 51.9442 55C23.251 55 0 31.7502 0 3.05584C0 1.36934 1.36934 0 3.05584 0H13.75C15.4453 0 16.8058 1.36053 16.8058 3.05584C16.8058 6.85927 17.4188 10.5444 18.5477 13.964C18.8838 15.0149 18.6434 16.2256 17.8001 17.0689L11.078 23.8237V23.8224Z",
    fill: "#0D1A2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.9d5783e157d3e7a676870b6d1c0a0f2a.svg";
export { ForwardRef as ReactComponent };